import s from "./FiltrosModalResp.module.css";
import logo from "../../assets/agape logo secondary.png";
import { SelectOutlineFilterSanteriaCategory, 
    SelectOutlineFilterSanteriaMaterial, 
    InputOutlinePrice, 
    CheckboxOutlineFilter 
} from "../CallToAction/CallToAction";

function FiltrosModalRespSanteria({ modalMenuRespControl, 
    categorias, handleCategorias, handlePrice, setPriceTextInput, 
    isChecked, handleCheckbox }) {

    const handleSelectChange = (e) => {
        const value = e.target.value;
        const getId = value.match(/\d+/);
        const id = getId[0] || null;

        if (value.includes("subId")) {
            // No es una categoría, entonces es una subcategoría.
            handleCategorias("categorias", id, 1);
        } else {
            // Se seleccionó una categoría.
            handleCategorias("categorias", id, 0);
        }
    }

    return (
        <div className={s.container}>
            <div className={s.header}>
                <span onClick={() => { modalMenuRespControl(false) }}>
                    Aplicar
                </span>
            </div>

            <div className={s.navegador}>

                <div className={s.title_container}>
                    <p>Filtros</p>
                    <div className={s.title_underline}></div>
                </div>

                {
                    categorias?.ofertasSanteria.length > 0 &&
                    <CheckboxOutlineFilter content="Ofertas" isChecked={isChecked} handleCheckbox={handleCheckbox} />
                }
                
                {/* <SelectOutlineFilterSanteriaCategory content="Categorias" fn={handleSelectChange} array={categorias.categorias} /> */}

                <SelectOutlineFilterSanteriaMaterial content="Materiales" onChange={(e)=>{handleCategorias("materiales", e.target.value)}} array={categorias.materiales} />

                <InputOutlinePrice onSubmit={handlePrice} onChange={setPriceTextInput} />

                <div className={s.separador} />

                <div className={s.footerFiltros}>
                    <div>
                        <img src={logo} alt="Logo Agape"/>
                        <p>Casa Central <br/> Av. San Martín 6863 - Buenos Aires</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FiltrosModalRespSanteria;